export const IN_PROGRESS_COMPLIANCE_STATUSES = [
  'IN_PROGRESS',
  'REVISION_IN_PROGRESS',
  'IN_REVIEW',
]
